import { MouseEvent } from "react";
import dayjs from "dayjs";
import {
  Button,
  TabbedDrawer,
  TabbedDrawerHeader,
  TabbedDrawerTitle,
  TabbedDrawerTab,
  TabbedDrawerCTA,
} from "@sellar-io/components";
import { FinanceDrawerInvoice } from "./FinanceDrawer";
import { InvoiceListResponseType } from "@sellar-io/api-v2/types";

enum InvoiceDrawerTabs {
  SUMMARY,
}

// TODO: when we need more tabs in the drawer we can add them here
// const tabs: TabbedNavigationTabType[] = [
//   { label: "Summary", index: InvoiceDrawerTabs.SUMMARY },
// ];

export const InvoiceDrawer = ({
  active,
  setActive,
  invoice,
}: {
  active: boolean;
  setActive: (value: boolean) => void;
  invoice?: InvoiceListResponseType[number];
}) => {
  const viewStripeInvoice = (e: MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    if (invoice?.stripeInvoiceUrl) {
      window.open(invoice.stripeInvoiceUrl, "_blank");
    }
  };

  const getSubtitle = () => {
    if (!invoice) return "";
    switch (invoice.status) {
      case "draft":
        return "Draft";
      case "issued":
        return `Issued: ${dayjs(invoice.issuedAt).format("DD/MM/YYYY")}`;
      case "paid":
        return `Paid: ${dayjs(invoice.paidAt).format("DD/MM/YYYY")}`;
      case "void":
        return "Void";
    }
  };
  return (
    <TabbedDrawer
      active={active}
      setActive={setActive}
      initTab={InvoiceDrawerTabs.SUMMARY}
    >
      <TabbedDrawerHeader>
        <TabbedDrawerTitle
          title={`Invoice # ${invoice?.customId || invoice?.stripeInvoiceId || ""}`}
          subtitle={getSubtitle()}
        />
      </TabbedDrawerHeader>

      <TabbedDrawerTab tab={InvoiceDrawerTabs.SUMMARY}>
        <FinanceDrawerInvoice invoice={invoice} />
      </TabbedDrawerTab>

      {/* TODO: get sellar credit invoices */}
      <TabbedDrawerCTA>
        <Button
          className="w-full"
          onClick={(e) => viewStripeInvoice(e)}
          disabled={!invoice?.stripeInvoiceUrl}
        >
          Download invoice
        </Button>
      </TabbedDrawerCTA>
    </TabbedDrawer>
  );
};
